import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, H1Text, LeftBackButtonText, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { useHistory } from 'react-router-dom';
import { axiosLoginInstance, BASE_URLS } from "../../api";
import { TOKENS, AUTH_CHALLENGES } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import OTP from "../../components/otp";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";
import RecaptchaModal from "../../components/recaptcha";
import {
    getOtpAuthErrorMessage,
    getOtpChallengeDetail,
    isOtpAuthError,
} from "../../utils/authOtp";

type Props = {
    history: {
        push: Function,
    },
}

const TemporaryPassword = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const history = useHistory();
    const [errorText, setErrorText] = useState('');
    const publicKey = localStorage.getItem('publicKey');
    const [showPassword, setShowPassword] = useState(false);
    const [showOTP, setShowOTP] = useState(false);
    const [otpDetail, setOtpDetail] = useState({
        userEmail: '',
        session: '',
        hint: '',
        status: '',
        authSuccessCallback: () => {},
    });
    const savedAuthData = useRef();
    const [showRecaptcha, setShowRecaptcha] = useState(false);


    useEffect(() => {
        if (history.location.state && history.location.state.errorMsg) {
            setErrorText(history.location.state.errorMsg);
        }
    }, [history.location.state]);

    const { handleSubmit, errors, control } = useForm();

    const showOtpChallenge = (entity, email, authSuccessCallback) => {
        setShowOTP(true);
        setOtpDetail({
            ...getOtpChallengeDetail(entity, email),
            authSuccessCallback,
        });
    };

    const handleOtpAuthError = (error) => {
        if (!isOtpAuthError(error)) {
            return false;
        }
        setErrorText('');
        setShowErrorMessage(true);
        setErrorMessage(getOtpAuthErrorMessage(error));
        return true;
    };

    const onSubmit = async (data, localRecaptchaToken = null) => {
        const params = {
            email: `${localStorage.getItem('email')}`,
            password: data.password,
        };
        // recatpcha modal for the rate limiting
        const config = {};
        if (typeof localRecaptchaToken === 'string') {
            config.headers = {
                'X-Captcha-Token': localRecaptchaToken,
            };
        }
        try {
            const { data: { entity } } = await axiosLoginInstance.post(`${BASE_URLS.AUTHENTICATE}`, params, config);
            const authSuccessCallback = async (authEntity) => {
                localStorage.setItem(TOKENS.SESSION_TOKEN, authEntity.session);
                setSuccess(true);
            };
            if (entity.challengeName === AUTH_CHALLENGES.CUSTOM_CHALLENGE) {
                showOtpChallenge(entity, params.email, authSuccessCallback);
            } else if (entity) {
                await authSuccessCallback(entity);
            }
        } catch (e) {
            if (handleOtpAuthError(e)) {
                return;
            }
            if ((e?.status || e?.response?.status || e?.data?.responseCode) === 429) {
                savedAuthData.current = data;
                setShowRecaptcha(true);
                return;
            }
            setErrorText('');
            setShowErrorMessage(true);
            if (e && e.data && e.data.responseCode === 401) {
                setErrorMessage('Please make sure your email and password are valid');
            } else {
                setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
            }            
        }
    }

    useEffect(() => {
        if (success) {
            props.history.replace('/setuppassword');
        }
    }, [success, props.history]);

    const onGlobalRecaptchaVerified = (token) => {
        setShowRecaptcha(false);
        onSubmit(savedAuthData.current, token);
    }

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => {props.history.push(`/connect/create?key=${btoa(publicKey)}`);}}
                        >
                            Back
                      </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                      </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                {
                    !showOTP && (
                        <FlexContainer
                            className="pt-3 pt-lg-5"
                            box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                            display="flow-root"
                        >
                            <H1Text className="px-1 px-md-4 mt-4">
                                ACCOUNT SETUP
                            </H1Text>
                            <Text className="px-1 px-md-4" paddingBottom="8px">
                                Enter the temporary password we sent to your email
                            </Text>
                            <Text className="px-1 px-md-4" paddingBottom="8px" fontWeight="600">
                                {`${localStorage.getItem('email')}`}
                            </Text>
                            <Hr />
                            <div className="px-1 px-md-4 mt-2">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <LabelText className="mt-4 mb-2">
                                        Temporary Password
                                </LabelText>
                                <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                                    <Controller
                                        defaultValue={""}
                                        control={control}
                                        color={errors.password ? "red" : "inherit"}
                                        border="0px !important"
                                        name="password"
                                        placeholder="Enter your Password"
                                        rules={{
                                            required: 'Password is required'
                                        }}
                                        as={<Input style={{
                                            marginTop: "0",
                                            marginBottom: "0px",
                                            width: "268px",
                                        }}
                                        type={showPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("password")} />}
                                    />
                                    <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                                    </InputWrapper>
                                    <ErrorMessage
                                        errors={errors}
                                        name="password"
                                        render={({ message }) => (
                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                        )}
                                    />
                                    <div>
                                        <SubmitButton
                                            style={{ width: '292px' }}
                                            type="submit"
                                        >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                    </div>
                                    {showerrorMessage && <PaymentError header={errorText ? errorText : errorMessage} message={null} />}
                                </form>
                            </div>
                        </FlexContainer>
                    )
                }
                {
                    showOTP && (
                        <FlexContainer
                            className="pt-3 pt-lg-5"
                            box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                            display="flow-root"
                        >
                            <OTP
                                isMobileView={false}
                                userEmail={otpDetail.userEmail}
                                firstHint={otpDetail.hint}
                                firstSession={otpDetail.session}
                                firstStatus={otpDetail.status}
                                setShowOTP={setShowOTP}
                                authSuccessCallback={otpDetail.authSuccessCallback}
                            />
                        </FlexContainer>
                    )
                }
            <RecaptchaModal
                visible={showRecaptcha}
                onVerified={onGlobalRecaptchaVerified}
            />
            </>
        } />
    )
};

export default TemporaryPassword;
